import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { Autocomplete, TextField } from '@mui/material';

RHFSelectOptions.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    defaultValue: PropTypes.any,
    isEdit: PropTypes.bool, // 👈 add prop
};

export default function RHFSelectOptions({ name, label, options, defaultValue, isEdit = false, ...other }) {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    console.log('isEdit', isEdit);
    console.log('defaultValue', options);
    let selectedOptionValue;

    if (isEdit) {
        selectedOptionValue = options.find((option) => option.value === defaultValue);
    }

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field: { onChange, value } }) => {
                console.log('value', value);
                const selectedOption = options.find((option) => option.value === value);

                if (isEdit) {
                    // 🔹 Show only value (read-only)
                    return (
                        <TextField
                            label={label}
                            value={selectedOptionValue ? selectedOptionValue.label : ''}
                            variant="outlined"
                            fullWidth
                            InputProps={{
                                readOnly: true, // prevent editing
                            }}
                            {...other}
                            error={!!errors[name]}
                            helperText={errors[name]?.message || ''}
                        />
                    );
                }

                // 🔹 Normal editable autocomplete
                return (
                    <Autocomplete
                        value={selectedOption || null}
                        onChange={(event, newValue) => {
                            onChange(newValue ? newValue.value : null);
                        }}
                        options={options}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={label}
                                variant="outlined"
                                fullWidth
                                {...other}
                                error={!!errors[name]}
                                helperText={errors[name]?.message || ''}
                            />
                        )}
                    />
                );
            }}
        />
    );
}
